import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  withStyles
} from '@material-ui/core';
import { Assignment, CloseTwoTone, Description, Movie, Person, PlayArrow } from '@material-ui/icons';
import moment from 'moment';
import React from 'react';
import Trans, { t } from '../../commons/Translate.js'

const StyledListItem = withStyles({
  secondaryAction: {
    paddingRight: '190px',
  }
})(ListItem)

const CustomListItem = ({item, onClick, onTaskAssignmentClick, onDelete, perspective}) => {
  perspective = perspective || 'recipient'
  const {
    createdAt,
    validUntil,
    assignedBy: { name: creator },
    assignedTo: { name: recipient },
    task: { title: taskTitle, pdfUrl, assignment: taskAssignment },
    student: {
      firstName: studentFirstName,
      lastName: studentLastName,
    },
    videoUrl,
    performedAt,
  } = item

  let itemTitle = <>Fall: <b>{taskTitle}</b>, Student:in <b>{studentFirstName} {studentLastName}</b></>
  if (performedAt) {
    itemTitle = <>{itemTitle}, {moment(performedAt).format('DD.MM.YYYY, HH:mm')} Uhr</>
  }
  const deleteBtnTitle = perspective === 'creator' ? t('Auftrag löschen') : t('Auftrag ablehnen')
  const itemSubtitleCreationTime = moment(createdAt).format('HH:mm')
  const itemSubtitleCreationDate = moment(createdAt).format('DD.MM.YYYY')
  const itemSubtitleUntilDate = moment(validUntil).format('DD.MM.YYYY, HH:mm')
  const itemSubtitle = perspective === 'creator' ?
    <Trans code="observation_assignment_item_subtitle_creator" substitutions={[recipient, itemSubtitleCreationDate, itemSubtitleUntilDate]}>
      Auftrag an <b>$0</b> vom <span title={t('$0 Uhr', [itemSubtitleCreationTime])}>$1</span>. Abzuschließen bis <b>$2 Uhr</b>.
    </Trans> :
    <Trans code="observation_assignment_item_subtitle_assignee" substitutions={[creator, itemSubtitleCreationDate, itemSubtitleUntilDate]}>
      Beauftragt von <b>$0</b> am <span title={t('$0 Uhr', [itemSubtitleCreationTime])}>$1</span>. Bitte bis <b>$2 Uhr</b> abschließen.
    </Trans>
  return <StyledListItem>
    <ListItemAvatar>
      <Avatar>
        <Person/>
      </Avatar>
    </ListItemAvatar>
    <ListItemText
      primary={itemTitle}
      secondary={itemSubtitle}
    />
    <ListItemSecondaryAction>
      <IconButton disabled={!taskAssignment} edge="end" onClick={event => onTaskAssignmentClick(event, item)}>
        <Tooltip title={t("Aufgabenstellung des Falls anzeigen")}>
          <Assignment/>
        </Tooltip>
      </IconButton>
      <IconButton disabled={!pdfUrl} edge="end" href={pdfUrl} target='_blank'>
        <Tooltip title={t(`Dokumentation von $0 aufrufen`, [`${studentFirstName} ${studentLastName}`])}>
          <Description/>
        </Tooltip>
      </IconButton>
      <IconButton disabled={!videoUrl} edge="end" href={videoUrl} target='_blank'>
        <Tooltip title={t(`Aufzeichnung von $0 aufrufen (Login erforderlich)`, [`${studentFirstName} ${studentLastName}`])}>
          <Movie/>
        </Tooltip>
      </IconButton>
      { onClick ? <IconButton edge="end" onClick={event => onClick(event, item)}>
        <Tooltip title={t("Beobachtung starten")}>
          <PlayArrow/>
        </Tooltip>
      </IconButton> : null }
      <IconButton edge="end" onClick={event => onDelete(event, item, perspective)}>
        <Tooltip title={deleteBtnTitle || t('Auftrag ablehnen')}>
          <CloseTwoTone/>
        </Tooltip>
      </IconButton>
    </ListItemSecondaryAction>
  </StyledListItem>
}

export default CustomListItem